module.exports = __webpack_public_path__ + "cabfa405a8f3422ec3f390368c4167bd.svg";